import { render, staticRenderFns } from "./ChannelIcon.vue?vue&type=template&id=1b2db26d&"
import script from "./ChannelIcon.vue?vue&type=script&lang=js&"
export * from "./ChannelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports